// routes.js
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';

import Setting from '../pages/Setting';
import Account from '../pages/Account';
import UserList from '../pages/users/List';
import UserDetails from '../pages/users/Details';
import AddUpdateUser from '../pages/users/AddUpdate';

import CustomerList from '../pages/customers/List';
import AddUpdateCustomer from '../pages/customers/AddUpdate';
import CustomerDetails from '../pages/customers/Details';

import BranchList from '../pages/branches/List';
import AddUpdateBranch from '../pages/branches/AddUpdate';

import ServiceList from '../pages/services/List';
import AddUpdateService from '../pages/services/AddUpdate';

import AppointmentList from '../pages/appointments/List';
import AddUpdateAppointment from '../pages/appointments/AddUpdate';
import AppointmentDetails from '../pages/appointments/Details';
import NotificationList from '../pages/notifications/List';

import ExpenseList from '../pages/expenses/List';
import AddUpdateExpense from '../pages/expenses/AddUpdate';

import ExpenseCategoryList from '../pages/expense_categories/List';
import AddUpdateExpenseCategory from '../pages/expense_categories/AddUpdate';

import SalesReport from '../pages/reports/SalesReport';
import ExpenseReport from '../pages/reports/ExpenseReport';
import TransactionList from '../pages/transactions/List';

import NotFound from '../pages/NotFound';  
import Booking from '../pages/public/Booking';


const routes = [
    {
        path: '/',
        component: Booking,
        meta: { requiresAuth: false, layout: 'public' }
    },
    {
        path: '/admin/dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, hideHeader: false }
    },
   
    {
        path: '/login',
        component: Login,
        meta: { requiresAuth: false, hideHeader: true }
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        meta: { requiresAuth: false, hideHeader: true }
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        meta: { requiresAuth: false, hideHeader: true }
    },

    {
        path: '/users/',
        component: UserList,
        meta: { requiresAuth: true , hideHeader: false  }
    },
    {
        path: '/users/create',
        component: AddUpdateUser,
        meta: { requiresAuth: true , hideHeader: false  }
    },
    {
        path: '/users/edit/:id',
        component: AddUpdateUser,
        meta: { requiresAuth: true , hideHeader: false  }
    },
    {
        path: '/users/:id',
        component: UserDetails,
        meta: { requiresAuth: true , hideHeader: false  }
    },

    // Customer Routes
    {
        path: '/customers',
        component: CustomerList,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/customers/create',
        component: AddUpdateCustomer,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/customers/edit/:id',
        component: AddUpdateCustomer,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/customers/:id',
        component: CustomerDetails,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Branch Routes
    {
        path: '/branches',
        component: BranchList,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/branches/create',
        component: AddUpdateBranch,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/branches/edit/:id',
        component: AddUpdateBranch,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Service Routes
    {
        path: '/services',
        component: ServiceList,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/services/create',
        component: AddUpdateService,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/services/edit/:id',
        component: AddUpdateService,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Appointment Routes
    {
        path: '/appointments',
        component: AppointmentList,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/appointments/create',
        component: AddUpdateAppointment,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/appointments/edit/:id',
        component: AddUpdateAppointment,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/appointments/:id',
        component: AppointmentDetails,
        meta: { requiresAuth: true, hideHeader: false }
    },

    {
        path: '/notifications',
        component: NotificationList,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Expense Routes
    {
        path: '/expenses',
        component: ExpenseList,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/expenses/create',
        component: AddUpdateExpense,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/expenses/edit/:id',
        component: AddUpdateExpense,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Expense Category Routes
    {
        path: '/expense-categories',
        component: ExpenseCategoryList,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/expense-categories/create',
        component: AddUpdateExpenseCategory,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/expense-categories/edit/:id',
        component: AddUpdateExpenseCategory,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Report Routes
    {
        path: '/reports/sales',
        component: SalesReport,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/reports/expenses',
        component: ExpenseReport,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Transactions
    {
        path: '/transactions',
        component: TransactionList,
        meta: { requiresAuth: true, hideHeader: false }
    },

    // Settings
    {
        path: '/settings',
        component: Setting,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/account',
        component: Account,
        meta: { requiresAuth: true, hideHeader: false }
    },

    {
        path: '*',
        component: NotFound,
        meta: { requiresAuth: false, hideHeader: true }
    }
];

export default routes;
